import { normalize, schema } from "normalizr";

export var ACTIVITY = new schema.Entity("activities");
export var ADMIN = new schema.Entity("admins");
export var ANSWER = new schema.Entity("answers");
export var AVATAR = new schema.Entity("avatars");
export var BOOK = new schema.Entity("books", {}, { idAttribute: "text_id" });
export var COMMENT = new schema.Entity("comments");
export var CONTACT = new schema.Entity("contacts");
export var DATA_EXPORT = new schema.Entity("dataExports");
export var DEAL = new schema.Entity("deals");
export var DIGEST = new schema.Entity("digests", {}, { idAttribute: "key" });
export var DISCOUNT_TOKEN = new schema.Entity("discountTokens", { idAttribute: "code" });
export var DISTRICT_ORG = new schema.Entity("districtOrgs");
export var ESTIMATE = new schema.Entity("estimates");
export var EXPECTATION_DIGEST = new schema.Entity("expectationDigests", {}, { idAttribute: "key" });
export var EVALUATION = new schema.Entity("evaluations");
export var INVOICE = new schema.Entity("invoices");
export var COIN_RECORD = new schema.Entity("coinRecords"); // Intentional name change
export var LOG = new schema.Entity("logs");
export var PARENT = new schema.Entity("parents");
export var PATCH = new schema.Entity("patches");
export var PHOTOGRAPH = new schema.Entity("photographs");
export var PLATFORM = new schema.Entity("platforms");
export var PERK = new schema.Entity("perks");
export var FURNITURE = new schema.Entity("furnitures");
export var QUESTION = new schema.Entity("questions");
export var QUIZ = new schema.Entity("quizzes");
export var RATING = new schema.Entity("ratings");
export var READING_LEVEL = new schema.Entity("readingLevels");
export var REPORT = new schema.Entity("reports", {}, { idAttribute: "report_key" });
export var RESPONSE = new schema.Entity("responses");
export var SCHOOL = new schema.Entity("schools");
export var SCHOOL_ORG = new schema.Entity("schoolOrgs");
export var STUDENT = new schema.Entity("students");
export var STUDENT_LIST = new schema.Entity("studentLists");
export var SURVEY_PROMPT = new schema.Entity("surveyPrompts", {}, { idAttribute: "key" });
export var TASK = new schema.Entity("tasks");
export var UPGRADE_TOKEN = new schema.Entity("upgradeTokens");
export var WIDGET_DIGEST = new schema.Entity("widgetDigests");

ADMIN.define({
	primary_school_org: SCHOOL_ORG,
});

ANSWER.define({
	question: QUESTION,
	evaluation: EVALUATION,
	gold_records: [COIN_RECORD],
});

BOOK.define({
	quiz_evaluations: [EVALUATION],
	quizzes: [QUIZ],
	answers: [ANSWER],
	reviews: [ANSWER],
	ratings: [RATING],
	responses: [RESPONSE],
	students: [STUDENT],
});

PARENT.define({
	children: [STUDENT],
});

QUIZ.define({
	answers: [ANSWER],
	evaluation: EVALUATION,
	gold_records: [COIN_RECORD],
});

REPORT.define({
	students: [STUDENT],
});

RESPONSE.define({
	activity: ACTIVITY,
	evaluation: EVALUATION,
});

SCHOOL.define({
	active_student_lists: [STUDENT_LIST],
});

STUDENT.define({
	avatar: AVATAR,
	parent: PARENT,
	current_tasks: [TASK]
});

STUDENT.define({
	avatar: AVATAR,
	parent: PARENT,
	all_tasks: [TASK]
});

STUDENT_LIST.define({
	students: [STUDENT],
	primary_admin: ADMIN,
	admins: [ADMIN],
});

TASK.define({
	subject: ACTIVITY,
	completion: RESPONSE,
});

UPGRADE_TOKEN.define({
	user: ADMIN,
});

WIDGET_DIGEST.define({
	user: ADMIN,
});

export function entities(data, dataSchema) {
	return normalize(data, dataSchema).entities;
}



// WEBPACK FOOTER //
// ./modules/lib/shared/Schema.js